<template>
  <div id="SideBar">
    <v-snackbar :color="type" :value="errors.length" :timeout="-1" :multi-line="true">
      <div class="d-flex">
        <v-icon v-if="type === 'success'">mdi-checkbox-marked-circle-outline</v-icon>
        <v-icon v-else>mdi-alert-circle-outline</v-icon>
        <ul v-if="!error500">
          <li v-for="(error, index) in errors" :key="error + index">
            {{ error }}
          </li>
        </ul>
        <ul v-else>
          <v-row class="mx-0 mt-1">
            <li v-for="(error, index) in errors" :key="error + index">
              {{ error }}
            </li>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon @click="copy(error500)" v-bind="attrs" role="button" v-on="on" class="ml-2" small>
                  mdi-checkbox-multiple-blank-outline
                </v-icon>
              </template>
              <span>Clique para copiar detalhes do erro</span>
            </v-tooltip>
          </v-row>
        </ul>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="closeMessages()"> Entendi </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import copyToClipboard from '../utils/copyToClipboard';
export default {
  name: 'MessagesError',
  props: {
    errors: {
      default: () => [],
      type: Array
    },
    error500: {
      default: () => null,
      type: Object
    },
    type: {
      default: 'error',
      type: String,
      validator: (value) => ['info', 'error', 'success'].includes(value.toLowerCase())
    }
  },
  data: () => ({}),
  computed: {},
  methods: {
    closeMessages() {
      this.$emit('closeMessages');
    },
    copy(str) {
      const data = JSON.stringify({ ...str });
      copyToClipboard(data);
    }
  }
};
</script>
